import loadable from '@loadable/component'

export const Showcase = loadable(() => import('./Showcase'))
export const ShowcaseImage = loadable(() => import('./ShowcaseImage'))
export const ShowcaseText = loadable(() => import('./ShowcaseText'))
export type { ShowcaseProps } from './Showcase'
export type {
  ShowcaseImageProps,
  ShowcaseImageRenderImageProps
} from './ShowcaseImage'
export type {
  ShowcaseTextProps,
  ShowcaseTextRenderLinkProps
} from './ShowcaseText'
